import { render } from "./SquadListBlock.vue?vue&type=template&id=2ec38d06"
import script from "./SquadListBlock.vue?vue&type=script&lang=js"
export * from "./SquadListBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__